import React from 'react';
import { useTranslation } from 'react-i18next';
import { Mission } from '../../../services/types/Missions';
import { customDateStr, getInitials } from '../../../shared/misc/utils';
import AvatarGroup from '../../Operations/Operation/AvatarGroup';
import GeneralInfoItem from '../../Operations/Operation/GeneralInfoItem';

export interface TeamMember {
  imgPath?: string;
  name: string;
  initials: string;
}

interface Props {
  mission: Mission;
}
const GeneralInfo: React.FC<Props> = ({ mission }) => {
  const { t } = useTranslation();

  const members =
    mission && mission.memberList
      ? mission.memberList.map((user) => ({
          name: user.fullName,
          initials: getInitials(user.fullName),
        }))
      : null;

  return (
    <div className="gi-items table-responsive">
      <GeneralInfoItem title={t('startDate')}>
        {customDateStr(mission.startDate, 'dd/MM/yyy')}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('endDate')}>
        {customDateStr(mission.endDate, 'dd/MM/yyy')}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('country')}>{t(`countryCode.${mission.country}`)}</GeneralInfoItem>
      <GeneralInfoItem title={t('destinationCountry')}>
        {t(`countryCode.${mission.destinationCountry}`)}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('esgMissionMembers')} classContent="avatar" minWidth={200}>
        {members && <AvatarGroup members={members} />}
      </GeneralInfoItem>
    </div>
  );
};

export default GeneralInfo;
